<script>
import $ from "jquery";
import {onBeforeUnmount, onMounted, onUnmounted, ref, watch} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import router from "@/router";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";

export default {
  name: "AuctionsPage",
  components: {BottomNavigation, LoadingPage},

  setup() {

    let loading = ref(false)

    let bids = ref([])
    let wallet = ref(null)

    let dialog = ref(false)

    let login_bid = ref({
      price:0,
      bid:null,
      action:'enter',
    })

    function load_bids(load) {

      if (load) loading.value = true

      FreeWorld.Heisenberg({type:'all'}, 'bids', true).then((res) => {

        loading.value = false
        bids.value = res.data.bids
        wallet.value = res.data.wallet

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_bids)
      })


    }
    load_bids(true)

    function decreaseTimer() {
      // برای هر آیتم در آرایه bids
      bids.value.forEach(item => {
        // تقسیم تایمر به ساعت، دقیقه و ثانیه
        let [hours, minutes, seconds] = item.timer.split(':').map(Number);
        // کاهش یک ثانیه از تایمر
        seconds--;
        // اگر زمان به صفر رسید، زمان را به 0:0:0 تنظیم کنید
        if (seconds < 0) {
          seconds = 59;
          minutes--;
          if (minutes < 0) {
            minutes = 59;
            hours--;
            if (hours < 0) {
              hours = 0;
              minutes = 0;
              seconds = 0;
              // اگر زمان به پایان رسید، اقدامات مورد نظر را انجام دهید، مثلاً توقف تایمر
            }
          }
        }
        // به‌روزرسانی تایمر در آرایه data
        item.timer = `${hours}:${minutes}:${seconds}`;
      });
    }

    let update_timer = null
    let update_bids = null

    onMounted(() => {
      update_timer = setInterval(decreaseTimer, 1000);
      update_bids = setInterval(() => {
        load_bids(false)
      }, 30000);
    })
    onBeforeUnmount(() => {
      clearInterval(update_timer)
      clearInterval(update_bids)
    })

    function open_products(id) {

      let div = document.getElementById('product' + id)
      let info = $("#info_prod" + id)
      let icon = $("#icon" + id)

      let rootFontSize = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('font-size'));
      let heightInRem = div.scrollHeight / rootFontSize;
      heightInRem = heightInRem.toFixed(0);

      if (div.style.height !== heightInRem + 'rem') {
        div.style.height = heightInRem + 'rem'
        info.removeClass('animate__fadeOut').addClass('animate__fadeIn')
        icon.removeClass('min_rotate_icon').addClass('rotate_icon')
      } else {
        window.innerWidth > 800 ? div.style.height = '14.5rem' : div.style.height = '14rem'
        info.removeClass('animate__fadeIn').addClass('animate__fadeOut')
        icon.removeClass('rotate_icon').addClass('min_rotate_icon')
      }

    }

    function login_bids(type , item) {

      switch (type) {
        case 'show' :
          if (!item.entered){
          login_bid.value.bid = item.id
          login_bid.value.price = item.price * (5 / 100)
            $("#dialog").removeClass('animate__fadeOut').addClass('animate__fadeIn')
          dialog.value = true
          }else {
            router.push({name:'AuctionInformation',params:{bid:item.id}})
          }
          break;

        case 'close' :
          $("#dialog").removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(()=>{
              dialog.value = false
              login_bid.value = {
                price:0,
                bid:null,
                action:'enter',
              }
            },700)
              break;

        case 'send' :
          if (wallet.value < login_bid.value.price){Swals.Fault('موجودی کیف پول شما کافی نمی باشد!');return false}
          loading.value = true
            FreeWorld.Heisenberg(login_bid.value , 'bids_act' , true).then((res)=>{

              loading.value = false
              if (res.data.event === 'price is less than the last price'){
                Swals.Fault('موجودی کیف پول شما کافی نمی باشد!')
              }else if(res.data.status === 'ok'){
                router.push({name:'AuctionInformation' , params:{bid:login_bid.value.bid}})
              }else{
                Swals.Fault('مشکلی برای ورود به مزایده رخ داده است!')
              }

            })
              break;
      }

    }


    let windowWidth = ref()
    const handleResize = ()=>{
      windowWidth.value = window.innerWidth
    };

    onMounted(()=>{
      window.addEventListener('resize', handleResize);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    watch(()=> windowWidth.value , (newWidth)=>{
      bids.value.forEach((item) => {
        let div = document.getElementById('product' + item.id);
        if (div) {
          newWidth > 800 ? div.style.height = '14.5rem' : div.style.height = '14rem';
        }
      });
    })

    return {

      open_products,
      bids,
      loading,
      login_bids,
      dialog,
      wallet,
      login_bid,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog" @click="login_bids('close')" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مزایده ها</p>
        <router-link :to="{name:'HomePage'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div v-if="bids.length === 0 && !loading" style="height: 45vh" class="d-flex justify-content-center align-items-end w-100 animate__animated animate__fadeIn">
      <div class="d-flex flex-column align-items-center justify-content-end">
        <img src="../assets/img/auction.png" class="mb-3 w-25" alt="">
        <p class="font-3 font-bold">مزایده ای برای نمایش وجود ندارد!</p>
      </div>
    </div>

    <div v-else class="w-100 p-body ">

      <div v-for="item in bids" :key="item.id" class="position-relative animate__animated animate__fadeInRight">

        <div :id="'product' + item.id"
             class="overflow-hidden product text-decoration-none bg-white mb-4-5 shadow-custom p-2 rounded-4 position-relative">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column justify-content-around w-60">
              <div class="overflow-hidden">
                <p class="font-bold font-5" :class="{'txtoverflow': item.name.length > 30}">{{ item.name }}</p>
              </div>

              <div class="overflow-hidden">
                <p class="font-5 my-2" :class="{'txtoverflow': item.brand.length > 25}">از برند {{ item.brand }}</p>
              </div>

              <div class="d-flex align-items-end mb-2">
                <img src="../assets/img/package2.png" class="icon-size-1">

                <p style="white-space: nowrap" class="font-6 mx-1">حجم محصول مزایده :</p>

                <div class="overflow-hidden">
                  <p :class="item.pnum.toString().length + item.unit.length > 10 ? 'txtoverflow':''"
                     class="font-5 font-color font-bold d-flex align-items-center">
                    <span class="mx-1">{{ item.pnum }} عدد</span>
                    <span class="">{{ item.unit }}</span>
                  </p>
                </div>
              </div>

              <div class="d-flex align-items-end">
                <img src="../assets/img/credit2.png" class="icon-size-1">

                <p style="white-space: nowrap" class="font-6 mr-1">قیمت پایه مزایده :</p>

                <p :class="item.price.toString().length > 10 ? 'txtoverflow':''"
                   class="mx-1 font-color font-bold d-flex align-items-end">
                  <span class="font-5">{{ item.price.toLocaleString() }}</span>
                  <span class="font-6 mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr my-2"></div>

            </div>


            <div class="img_prod rounded-3 animated-background">
              <img class="w-100 h-100 rounded-3" :src="item.pic" alt="">
            </div>

          </div>

          <div class="d-flex align-items-center justify-content-between mt-2 mb-4-5">

            <div class="d-flex align-items-center">
              <img style="width: 1.2rem" class="ml-2" src="../assets/img/store_color.svg" alt="">

              <div class="overflow-hidden d-flex align-items-center w-100">
                <div class="d-flex align-items-center w-100" :class="item.shopname.length > 20 ? 'txtoverflow':''">
                  <p class="ml-1 font-5">{{ item.shopname }}</p>

                  <img class="icon-size-1" v-if="item.shoprate == 1" src="../assets/img/rate1.svg" alt="">
                  <img class="icon-size-8" v-else-if="item.shoprate == 2" src="../assets/img/rate2.svg" alt="">
                  <img class="icon-size-1" v-else-if="item.shoprate == 3" src="../assets/img/rate3.svg" alt="">
                  <img class="icon-size-8" v-else-if="item.shoprate == 4" src="../assets/img/rate4.svg" alt="">
                  <img class="icon-size-1" v-else-if="item.shoprate == 5" src="../assets/img/rate5.svg" alt="">
                  <img class="icon-size-8" v-else-if="item.shoprate == 6" src="../assets/img/rate6.svg" alt="">
                </div>
              </div>
            </div>

            <div v-if="item.start" @click="login_bids('show' , item)" class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">ورود به مزایده</div>
            <div v-else class="bg-color-light py-1 px-2 font-5 rounded-pill shadow-custom">هنوز شروع نشده</div>
          </div>

          <div :id="'info_prod' + item.id" class="animate__animated rounded-3 mb-5 p-body py-3 drop_shadow">
            <div class="d-flex justify-content-start align-items-center mb-2">
              <img src="../assets/img/clock.png" class="icon-size-1">

              <div v-if="item.start" class="d-flex align-items-center">
              <p class="m-0 me-2 font-5">زمان باقی مانده مزایده:</p>
              <p class="m-0 me-2 font-5 font-bold font-color">{{ item.timer }}</p>
              </div>

              <p v-else class="font-4 font-color-red me-2">مزایده هنوز شروع نشده</p>
            </div>

            <div class="d-flex justify-content-start align-items-center mb-2">
              <img src="../assets/img/bid.png" class="icon-size-1">
              <p class="mx-2 font-5">آخرین قیمت مزایده :</p>
              <div class="d-flex justify-content-center align-items-center">
                <p class="font-5 font-bold font-color">{{ item.price_last.toLocaleString() }}</p>
                <p class="font-6 mr-1 font-bold font-color">تومان</p>
              </div>
            </div>

            <div class="d-flex justify-content-start align-items-center mb-2">
              <img src="../assets/img/increase.png" class="icon-size-1">
              <p class="mx-2 font-5">مبلغ هر گام :</p>
              <div class="d-flex justify-content-center align-items-center">
                <p class="font-5 font-bold font-color">{{ item.price_step.toLocaleString() }}</p>
                <p class="font-6 mr-1 font-bold font-color">تومان</p>
              </div>
            </div>

            <div class="d-flex justify-content-start align-items-center">
              <img src="../assets/img/information.svg" class="icon-size-1">
              <a href="https://market-app.ir/rules?action=bidrules" target="_blank" class="me-2 text-decoration-none font-color font-4">قوانین مزایده</a>
            </div>
          </div>
        </div>

        <div @click="open_products(item.id)"
             class="icon_show rounded-pill bg-white shadow-custom position-absolute d-flex justify-content-center align-items-center">
          <img :id="'icon' + item.id" src="../assets/img/bottomarrow.png" class="position-absolute min_rotate_icon icon-size-0-5">
        </div>
      </div>

    </div>

    <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_dialog_wallet.svg" alt="">
          <p class="text-white font-4">کیف پول</p>
        </div>

        <div class="p-3">
          <p class="font-5 text-center mb-4">برای شرکت در مزایده ، کیف پول شما باید 5درصد مبلغ پایه مزایده شارژ
            شود</p>


          <p class="font-bold font-4 font-color mb-2">مبلغ مورد نیاز برای ورود به مزایده</p>
          <div
              class="p-3 bg-color-blue-light shadow-custom d-flex justify-content-center align-items-center rounded-4 w-100 mb-4">
            <p class="d-flex align-items-center font-4 font-bold font-color-green">
              <span class="">{{ login_bid.price.toLocaleString() }}</span>
              <span class="mr-1">تومان</span>
            </p>
          </div>

          <p class="font-bold text-center font-4 font-color mb-3">آیا پرداخت می کنید؟</p>

          <div v-if="wallet < login_bid.price" class="animate__animated animate__flash d-flex align-items-center justify-content-center mb-4">
            <img style="height: 25px" src="../assets/img/icon_error.svg" alt="">
            <p class="font-4 font-color-red mr-2">موجودی کیف پول شما کمتر از مقدار مجاز است</p>
          </div>

          <div class="shadow-custom rounded-4 p-3 mb-4">
            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center">
                <img style="height: 25px" class="icon_shadow" src="../assets/img/icon_wallet_color.svg" alt="">

                <div class="d-flex align-items-center">
                  <span class="mx-1 font-5">موجودی کیف پول شما :</span>
                  <span class="font-color font-4 font-bold mx-1">{{ wallet.toLocaleString() }}</span>
                  <span class="font-color font-5">تومان</span>
                </div>
              </div>

            </div>

            <div class="d-flex justify-content-center align-items-center mt-3">
              <router-link :to="{name:'WalletPage'}" class="text-decoration-none w-60">
              <p class="p-2 text-center bg-green rounded-3 font-5 text-white">افزایش موجودی کیف پول</p>
              </router-link>
            </div>
          </div>

          <div class="d-flex justify-content-center align-items-center">
            <v-btn @click="login_bids('send')" class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">ارسال</v-btn>
          </div>

        </div>
      </div>
    </div>

    <BottomNavigation></BottomNavigation>

  </div>

</template>


<style scoped>

.icon_show {
  left: 50%;
  bottom: -1.5rem;
  transform: translate(-50%, 0);
  padding: 1.5rem;
}

.product {
  transition: .5s;
}

@media (min-width: 800px) {
  .img_prod {
    width: 30% !important;
    height: 10.5rem !important;
  }
  .product{
    height: 14.5rem;
  }
}

@media (max-width: 799px) {
  .product{
    height: 14rem;
  }
}
.img_prod {
  width: 35%;
  height: 8.5rem;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

.drop_shadow {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 0px 55px -12px inset, rgba(0, 0, 0, 0.3) 0px 0px 0px 0px inset, inset 0 0 15px 0 #c7c7c7;
}

.rotate_icon {
  transform: rotate(180deg);
  transition: .5s;
}

.min_rotate_icon {
  transform: rotate(3deg);
  transition: .5s;
}

</style>